import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import { SUBSCRIPTION_PLAN } from '@gymaholic/packages'
import { getUrlWithQueryStringUtil } from 'packages/src'

export function getPremiumYearlyUrlRouteUtil () {
  return getUrlWithQueryStringUtil(ROUTE_PATH.PREMIUM, { plan: SUBSCRIPTION_PLAN.PREMIUM_YEARLY_2025 })
}
